<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form
        :model="where"
        label-width="90px"
        class="ele-form-search"
        @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="群组名称">
              <el-input clearable v-model.trim="where.bot_group_name" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="群组ID">
              <el-input clearable v-model.trim="where.bot_group_id" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <ele-pro-table
        ref="table"
        :where="where"
        :datasource="url"
        :columns="columns"
        :selection.sync="selection"
        :page-size="20"
        height="calc(100vh - 315px)">
        <template slot="toolbar">
          <el-button size="small" type="primary" icon="el-icon-plus" class="ele-btn-icon" @click="createOne"
            v-if="permission.includes('sys:acceptor:add')">添加</el-button>
          <el-button
            size="small"
            type="danger"
            icon="el-icon-delete"
            class="ele-btn-icon"
            :disabled="!selection.length"
            @click="removeBatch"
            v-if="permission.includes('sys:acceptor:delete')">删除</el-button>
          <el-button size="small" type="warning" icon="el-icon-refresh" class="ele-btn-icon" @click="initData"
            v-if="permission.includes('sys:acceptor:edit')">初始化</el-button>
        </template>
        <template slot="action" slot-scope="{ row }">
          <el-button size="small" type="primary" class="ele-btn-icon" @click="openBind(row)"
            v-if="permission.includes('sys:acceptor:edit')">绑定</el-button>
          <el-popconfirm class="ele-action" title="确定要删除此承兑吗？" @confirm="remove(row)"
            v-if="permission.includes('sys:acceptor:delete')">
            <el-button size="small" type="danger" class="ele-btn-icon" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </ele-pro-table>
    </el-card>
    <acceptor-bind-dialog :acceptor="bindRow" :visible.sync="showBind" @done="reload" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AcceptorBindDialog from './acceptor-bind-dialog';

export default {
  name: 'SystemAcceptor',
  components: { AcceptorBindDialog },
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return {
      url: '/acceptor/index',
      columns: [
        { columnKey: 'selection', type: 'selection', width: 45, align: 'center', fixed: 'left' },
        { prop: 'id', label: '序号', width: 70, align: 'center', fixed: 'left' },
        { prop: 'bot_group_name', label: '群组名称', showOverflowTooltip: true, minWidth: 140, align: 'center' },
        { prop: 'bot_group_id', label: '群组ID', showOverflowTooltip: true, minWidth: 140, align: 'center' },
        { prop: 'rate', label: '汇率', showOverflowTooltip: true, minWidth: 100, align: 'center' },
        { prop: 'balance', label: '余额', showOverflowTooltip: true, minWidth: 110, align: 'center' },
        { columnKey: 'action', label: '操作', width: 160, align: 'center', resizable: false, slot: 'action', fixed: 'right' }
      ],
      where: {},
      selection: [],
      bindRow: null,
      showBind: false
    };
  },
  methods: {
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    reset() {
      this.where = {};
      this.reload();
    },
    createOne() {
      this.$confirm('确定创建一条承兑记录吗？', '提示', { type: 'warning' })
        .then(() => {
          this.request('/acceptor/create', {}).then((ok) => {
            if (ok) this.reload();
          });
        })
        .catch(() => {});
    },
    openBind(row) {
      this.bindRow = row;
      this.showBind = true;
    },
    request(url, params) {
      const loading = this.$loading({ lock: true });
      return this.$http.post(url, params).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          return true;
        }
        this.$message.error(res.data.msg);
        return false;
      }).catch((e) => {
        loading.close();
        this.$message.error(e.message);
        return false;
      });
    },
    remove(row) {
      this.request('/acceptor/delete', { id: row.id }).then((ok) => {
        if (ok) this.reload();
      });
    },
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请选择');
        return;
      }
      this.$confirm('确定要删除选中的承兑吗?', '提示', { type: 'warning' }).then(() => {
        this.request('/acceptor/delete', { id: this.selection.map((d) => d.id) }).then((ok) => {
          if (ok) this.reload();
        });
      }).catch(() => {});
    },
    initData() {
      this.$confirm('初始化将清空全部承兑数据且不可恢复，确定继续？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.request('/acceptor/initData', {}).then((ok) => {
          if (ok) {
            this.selection = [];
            this.reload();
          }
        });
      }).catch(() => {});
    }
  }
};
</script>
